import Vue from 'vue'
import Vuex from 'vuex'
import Attack from '../../src/request/request'

Vue.use(Vuex)

const state = {
	menuState: 0,
	objectUid: null,
	valbody: null,
	dataEntlist: null,
	dataotherlist: null,
	dataGovlist: null,
	dataParklist: null,
	dataWtlist: null,
	// 机构名称列表
	dataNamelist: null,
	isRenderingState: null,
	changeobjlist: null,
	getNameLists: null,
	detailist: null,
	showlistState: null,
	currentComponyName: null
}

const getters = {

}

const actions = {

}

const mutations = {
	changeMenuState(state, data) {
		state.menuState = data
	},
	changeCurrUid(state, data) {
		state.objectUid = data
	},
	changeCurVal(state, data) {
		state.valbody = data
	},
	// 企业数据
	dataEntForm(state, data) {
		state.dataEntlist = data
	},
	// 其他数据
	DataotherForm(state, data) {
		state.dataotherlist = data
	},
	// 政府数据
	dataGovForm(state, data) {
		state.dataGovlist = data
	},
	// 工业园
	dataParkForm(state, data) {
		state.dataParklist = data
	},
	dataWtForm(state, data) {
		state.dataWtlist = data
	},
	// 存储机构名称列表
	setNameList(state, data) {
		state.dataNamelist = data
	},
	changeIsRendering(state, data) {
		state.isRenderingState = data
	},
	changeobj(state, data) {
		state.changeobjlist = data
	},
	// 存储预案信息
	getNameList(state, data) {
		state.getNameLists = data
	},
	dataAll(state, data) {
		state.detailist = data
	},
	// 控制新增直接显示类型
	showlist(state, data) {
		state.showlistState = data
	},
	setCurrentComponyName(state, data) {
		state.currentComponyName = data
	}
}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	modules: {

	},
	strict: 'debug'
})


// WEBPACK FOOTER //
// ./src/store/index.js